import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Create")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardTable = _resolveComponent("CardTable")!

  return (_openBlock(), _createBlock(_component_CardTable, {
    ref: "tableRef",
    name: "Car",
    header: $setup.tableHeader,
    endpoint: "car-year",
    modelValue: $setup.tableData,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tableData) = $event)),
    loadingProp: $setup.loading,
    breadcrumbs: $setup.breadcrumbs,
    currentIndex: $setup.currentIndex,
    onChangeIndex: _cache[1] || (_cache[1] = (index) => ($setup.currentIndex = index)),
    customEdit: true,
    customProperties: $setup.customProperties,
    defaultSearch: '',
    filterData: $setup.filterData
  }, _createSlots({
    "cell-no": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString(row.no), 1)
    ]),
    "cell-tags": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString(row?.tags.length ? row.tags.map((t) => t.name).join(', ') : '-'), 1)
    ]),
    "cell-edit": _withCtx(({ row }) => [
      _createVNode(_component_router_link, {
        to: `car-management/edit-car/${row.id}`,
        class: "menu-link px-3"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    create: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: "/car-function/car-management/add-car",
        class: "btn btn-success me-4"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    _renderList($setup.loopers, (item, i) => {
      return {
        name: `cell-${item}`,
        fn: _withCtx(({ row: property }) => [
          _createTextVNode(_toDisplayString(property[item] || '-'), 1)
        ])
      }
    })
  ]), 1032, ["header", "modelValue", "loadingProp", "breadcrumbs", "currentIndex", "customProperties", "filterData"]))
}